/**
 * PLP product card horizontal gallery:
 * - Swipe at last/first slide wraps with smooth scroll (touch).
 * - Hint bar thumb tracks scroll position.
 * Delegated touch + per-shell scroll listeners (works after AJAX PLP).
 */
(function () {
  'use strict';

  var SWIPE_MIN = 48;
  var EDGE_EPS = 4;
  var startX = null;
  var startGallery = null;

  function maxScroll(g) {
    return Math.max(0, g.scrollWidth - g.clientWidth);
  }

  function updateShellScroll(shell) {
    if (!shell || !shell.style) return;
    var g = shell.querySelector('.product-item__image-gallery');
    if (!g) return;
    var maxS = maxScroll(g);
    var p = maxS <= 0 ? 0 : g.scrollLeft / maxS;
    shell.style.setProperty('--plp-gallery-scroll', String(p));
  }

  function bindGalleryShell(shell) {
    if (!shell || shell.getAttribute('data-plp-gallery-shell-bound') === '1') return;
    var g = shell.querySelector('.product-item__image-gallery');
    if (!g) {
      shell.setAttribute('data-plp-gallery-shell-bound', '1');
      return;
    }
    if (!shell.querySelector('.product-item__image-gallery-hint')) {
      shell.setAttribute('data-plp-gallery-shell-bound', '1');
      return;
    }
    shell.setAttribute('data-plp-gallery-shell-bound', '1');
    var onScrollOrResize = function () {
      updateShellScroll(shell);
    };
    g.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    window.requestAnimationFrame(onScrollOrResize);
  }

  function initPlpGalleryShells() {
    document.querySelectorAll('.product-item__image-gallery-shell').forEach(bindGalleryShell);
  }

  function onTouchStart(e) {
    if (!e.target || !e.target.closest) return;
    var g = e.target.closest('.product-item__image-gallery');
    if (!g || e.touches.length !== 1) return;
    startGallery = g;
    startX = e.touches[0].clientX;
  }

  function onTouchEnd(e) {
    if (startGallery == null || startX == null) return;
    if (!e.changedTouches || !e.changedTouches.length) {
      startGallery = null;
      startX = null;
      return;
    }
    var g = startGallery;
    var dx = e.changedTouches[0].clientX - startX;
    startGallery = null;
    startX = null;

    var maxS = maxScroll(g);
    if (maxS <= EDGE_EPS) return;

    var sl = g.scrollLeft;
    var nearEnd = sl >= maxS - EDGE_EPS;
    var nearStart = sl <= EDGE_EPS;

    if (nearEnd && dx < -SWIPE_MIN) {
      g.scrollTo({ left: 0, behavior: 'smooth' });
    } else if (nearStart && dx > SWIPE_MIN) {
      g.scrollTo({ left: maxS, behavior: 'smooth' });
    }
  }

  function onTouchCancel() {
    startGallery = null;
    startX = null;
  }

  function start() {
    initPlpGalleryShells();
    if (typeof window.jQuery !== 'undefined') {
      window.jQuery(document.body).on('loadItemsList.plpGallery', function () {
        window.requestAnimationFrame(initPlpGalleryShells);
      });
    }
  }

  document.addEventListener('touchstart', onTouchStart, { passive: true });
  document.addEventListener('touchend', onTouchEnd, { passive: true });
  document.addEventListener('touchcancel', onTouchCancel, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
